require('./loanMovements.scss');
const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const classNames = require('classnames');
// @ helpers
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;
const { findActiveFilters } = require('utilities/filtersHelper');
// @ components
const LoanFilter = require('../loanFilter/loanFilter');
const LoanMovementsDetail = require('../loanMovementsDetail/loanMovementsDetail');
const LoanMovementsTableRow = require('../loanMovementsTableRow/loanMovementsTableRow');
const LoanMovementsFiltersHeader = require('../loanMovementsFiltersHeader/loanMovementsFiltersHeader');
const LoanCollectiveTag = require('../../loanCollectiveTag/loanCollectiveTag');
// @ commons
const { EmptyState } = require('commonsComponents/emptyState');
const { LastMovementsTable } = require('commonsComponents/lastMovementsTable');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { OKTableRow } = require('commonsComponents/OKTableRow');
// @ actions
const {
    clearLoanMovementsFilters,
    requestLoanMovements,
    setLoanMovementsFilters,
    requestNextPage,
    resetLoanMovementsFilter
} = require('../../../../actions/loansMovements');
// @ constants
const { LAST_MOVEMENTS_TABLE_CURRENT_MONTH_KEY } = require('constants/commonsComponents');
const language = getLanguage();
//@utilities
const { trackViewAndComercialSpace } = require('utilities/taggingViewHelper');
const {
    commonAnalyticsId,
    commonCatalogue,
    commonCatalogueFilters,
    commonFilterAnalyticsId,
} = require('utilities/taggingCommonCatalogue');
const { recordLinkV2 } = require('utilities/tagging');
//@analytics
const { catalogue, analyticsId } = require('../../analytics/loansAndMortgagesAnalytics');

class LoanMovements extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            expandedRowId: '',
            filtersOpen: false
        };

        this.handleRowClick = this.handleRowClick.bind(this);
        this.buildMovementsTable = this.buildMovementsTable.bind(this);
        this.handleFilterButtonClick = this.handleFilterButtonClick.bind(this);
        this.handleSetFilters = this.handleSetFilters.bind(this);
        this.handleToggleFilters = this.handleToggleFilters.bind(this);
        this.handleClearFilters = this.handleClearFilters.bind(this);
        this.handleNextPage = this.handleNextPage.bind(this);
        this.handleResetFilter = this.handleResetFilter.bind(this);
    }

    componentDidMount() {
        const { immLoan } = this.props;
        trackViewAndComercialSpace({
            immLoan,
            analyticView: catalogue[analyticsId.PAGE_VIEW_MOVEMENTS],
            productImpressionList: 'loanMovements'
        });
    }

    buildEmptyState() {
        const primaryText = formatText('loanMovements-emptyState');

        return (
            <EmptyState
                primaryText={primaryText}
                iconType="noitems-banking" />
        );
    }

    buildError() {
        const { loanId, requestLoanMovements } = this.props;
        const handleRequest = () => {
            recordLinkV2(commonCatalogue[commonAnalyticsId.RETRY_BUTTON]());
            requestLoanMovements(loanId);
        };
        const primaryText = formatText('loanMovements-errorMessage');
        const retryText = formatText('loanMovements-retry');
        const retryButton = (
            <OKButton
                onClick={handleRequest}
            >
                {retryText}
            </OKButton>
        );

        return (
            <EmptyState
                primaryText={primaryText}
                button={retryButton}
                iconType="nointernet-banking" />
        );
    }

    buildBadge() {
        const { immLoan } = this.props;

        return (
            <LoanCollectiveTag
                extraClass="loans-movements__collective-tag"
                immLoan={immLoan}
            />
        );
    }

    buildHeader() {
        const { immLoanMovements } = this.props;
        const immFilter = immLoanMovements.get('filters');
        const title = formatText('loanMovements-movements');
        const badge = this.buildBadge();
        const headerClasses = classNames('loans-movements__header',
            {
                'loans-movements__header--has-filters': findActiveFilters(immFilter)
            }
        );

        let modal;
        if (this.state.filtersOpen) {
            modal = (
                <LoanFilter
                    immFilter={immFilter}
                    onSetFilters={this.handleSetFilters}
                    onCloseClick={this.handleToggleFilters}
                />
            );
        }

        let filterLabels;
        if (findActiveFilters(immFilter)) {
            filterLabels = (
                <LoanMovementsFiltersHeader
                    immFilter={immFilter}
                    onResetFilter={this.handleResetFilter}
                    onClearFilters={this.handleClearFilters}
                />
            );
        }

        return (
            <section className={headerClasses}>
                <OKBoxTitle value={title} />
                {badge}
                <div className="loans-movements__header-filters pull-right">
                    <OKButton
                        id="btn_loans-movement-filters"
                        modifier="task"
                        onClick={this.handleFilterButtonClick}
                    >
                        <i className="icon-filtrar" />
                    </OKButton>
                </div>
                {modal}
                {filterLabels}
            </section>
        );
    }

    buildMovementsTable() {
        const { immLoanMovements } = this.props;

        return (
            <LastMovementsTable
                groupByDate={true}
                rowComponent={LoanMovementsTableRow}
                immTransactionsByOrder={immLoanMovements.get('byOrder')}
                immTransactionsById={immLoanMovements.get('byId')}
                columnsCount={6}
                expandedRowId={this.state.expandedRowId}
                expandedRowComponent={LoanMovementsDetail}
                onRowClick={this.handleRowClick}
                id="loans-movements-table"
                currentMonthKey={LAST_MOVEMENTS_TABLE_CURRENT_MONTH_KEY}
                language={language}
            >
                <thead>
                    <OKTableRow asHeader={true}>
                        <OKTableCell />
                        <OKTableCell asHeader={true}>
                            <FormattedText value="loanMovements-operationDate" />
                        </OKTableCell>
                        <OKTableCell asHeader={true}>
                            <FormattedText value="loanMovements-valueDate" />
                        </OKTableCell>
                        <OKTableCell asHeader={true}>
                            <FormattedText value="loanMovements-description" />
                        </OKTableCell>
                        <OKTableCell className="text-right" asHeader={true}>
                            <FormattedText value="loanMovements-amortizedCapital" />
                        </OKTableCell>
                        <OKTableCell className="text-right" asHeader={true}>
                            <FormattedText value="loanMovements-pendingCapital" />
                        </OKTableCell>
                    </OKTableRow>
                </thead>
            </LastMovementsTable>
        );
    }

    buildNextPageButton() {
        const { immLoanMovements } = this.props;
        const hasErrors = !!immLoanMovements.get('error');
        let content;

        if (!hasErrors && immLoanMovements.get('nextPage')) {
            if (immLoanMovements.get('isFetchingNextPage')) {
                content = <LoadingSection />;
            } else if (immLoanMovements.get('byOrder').size > 0) {
                content = (
                    <div className="loans-movements__more-movements">
                        <OKButton modifier="link-complementary" onClick={this.handleNextPage}>
                            <FormattedText value="loanMovements-moreMovements" />
                        </OKButton>
                    </div>
                );
            }
        }

        return content;
    }

    handleClearFilters() {
        this.props.clearLoanMovementsFilters(this.props.loanId);
    }

    handleFilterButtonClick() {
        this.setState({
            filtersOpen: true
        });
        recordLinkV2(commonCatalogueFilters[commonFilterAnalyticsId.FILTER_BUTTON_CLICK]());
    }

    handleNextPage() {
        this.props.requestNextPage(this.props.loanId);
    }

    handleResetFilter(filter) {
        const { requestLoanMovements, resetLoanMovementsFilter } = this.props;
        resetLoanMovementsFilter(filter);
        requestLoanMovements(this.props.loanId);
    }

    handleRowClick(rowId) {
        recordLinkV2(
            catalogue[analyticsId.CLICK_CHEVRON](rowId !== this.state.expandedRowId)
        );
        this.setState(function (previousState) {
            return { expandedRowId: (rowId === previousState.expandedRowId) ? '' : rowId }
        });
    }

    handleSetFilters(filters) {
        const { loanId, setLoanMovementsFilters } = this.props;
        setLoanMovementsFilters(filters, loanId);
    }

    handleToggleFilters() {
        this.setState({
            filtersOpen: !this.state.filtersOpen
        });
    }

    render() {
        const { immLoanMovements } = this.props;
        const header = this.buildHeader();
        const nextPageButton = this.buildNextPageButton();
        let content;

        if (immLoanMovements.get('isFetching')) {
            content = <LoadingSection />;
        } else if (immLoanMovements.get('error')) {
            content = this.buildError();
        } else if (immLoanMovements.get('byOrder').isEmpty()) {
            content = this.buildEmptyState();
        } else {
            content = this.buildMovementsTable();
        }

        return (
            <OKSectionBox>
                {header}
                {content}
                {nextPageButton}
            </OKSectionBox>
        );
    }
}

LoanMovements.propTypes = {
    immLoan: PropTypes.object.isRequired,
    immLoanMovements: PropTypes.object.isRequired,
    requestLoanMovements: PropTypes.func.isRequired,
    setLoanMovementsFilters: PropTypes.func.isRequired,
    clearLoanMovementsFilters: PropTypes.func.isRequired,
    loanId: PropTypes.string.isRequired,
    requestNextPage: PropTypes.func.isRequired,
    resetLoanMovementsFilter: PropTypes.func.isRequired
};

module.exports = connect(null, {
    requestLoanMovements,
    setLoanMovementsFilters,
    clearLoanMovementsFilters,
    requestNextPage,
    resetLoanMovementsFilter
})(LoanMovements);
